import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FieldWrapper } from '@ngx-formly/core';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { HIDEABLE_SWITCH_KEY_PREFIX } from '../formly-editor/formly-editor.component';

@Component({
  selector: 'formly-deactivable-wrapper',
  templateUrl: './formly-deactivable-wrapper.component.html'
})
@UntilDestroy()
export class FormlyDeactivableWrapperComponent extends FieldWrapper implements OnInit, AfterViewInit {
  _deactivableControl: FormControl = null;
  _hideableKey = '';

  ngOnInit(): void {
    this._hideableKey = this?.props?.deactivable?.siblingKeys.find((anyKey) => anyKey.includes(HIDEABLE_SWITCH_KEY_PREFIX));
    if (!this._hideableKey) {
      console.warn('Toggle not present for current row!');
      return;
    }
    this._deactivableControl = this.formControl.get(this._hideableKey) as FormControl;
    if (this._deactivableControl.value !== true && this._deactivableControl.value !== false) {
      this._deactivableControl.patchValue(this.model[this._hideableKey]);
    }

    if (!this?.props?.isEditable) {
      this.formControl.disable({onlySelf: true, emitEvent: false});
      this.formControl.updateValueAndValidity({ emitEvent: false });
      return;
    }
    this._listenToggleChanges();
    this._applyToggleState(this._deactivableControl.value, false);
  }

  ngAfterViewInit(): void {
    if (!this._deactivableControl || !this?.props?.isEditable) {
      return;
    }

    // Formly attaches field validators while creating the wrapped view. Reapply the
    // toggle after that lifecycle has completed so required controls contribute to
    // the root form validity when an enabled row is restored from persisted data.
    this._applyToggleState(this._deactivableControl.value, true);
  }

  private _listenToggleChanges(): void {
    if (!this?.props?.deactivable?.siblingKeys) {
      return;
    }
    this._deactivableControl.valueChanges
      .pipe(
        untilDestroyed(this),
        filter((value) => value === true || value === false),
        distinctUntilChanged()
      )
      .subscribe((isActive) => this._applyToggleState(isActive, true));
  }

  private _applyToggleState(isActive: boolean, emitEvent: boolean): void {
    if (this.field.props.disabled || (isActive !== true && isActive !== false)) {
      return;
    }

    for (const siblingKey of this.props.deactivable?.siblingKeys.filter((key) => key !== this._hideableKey)) {
      const control = this.form.get(siblingKey);
      if (!control) {
        continue;
      }
      if (isActive) {
        control.enable({ emitEvent: false });
      } else {
        control.disable({ emitEvent: false });
      }
      control.updateValueAndValidity({ emitEvent: false });
    }

    this.formControl.updateValueAndValidity({ emitEvent });
    if (this.form !== this.formControl) {
      this.form.updateValueAndValidity({ emitEvent });
    }
  }
}
